import './LinkComp.scss';
import Component from './LinkComp.js';
export default Component;
